import { composeEventHandlers } from '@radix-ui/primitive';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { Presence } from '@radix-ui/react-presence';
import { Primitive } from '@radix-ui/react-primitive';
import { type ComponentPropsWithoutRef, type ComponentRef, forwardRef, memo } from 'react';

import {
  PANEL_OVERLAY_NAME,
  type ScopeProps,
  usePanelContext,
} from '~/components/v2/components/shared/panel/PanelProvider';
import { getPanelState } from '~/components/v2/components/shared/panel/utils/getPanelState';

export type PanelOverlayProps = ComponentPropsWithoutRef<typeof Primitive.div> & {
  forceMount?: boolean;
};

export const PanelOverlay = memo(
  forwardRef<ComponentRef<typeof Primitive.div>, ScopeProps<PanelOverlayProps>>(
    ({ __scopePanel, className, forceMount, style, ...restOfProps }, forwardedRef) => {
      const context = usePanelContext(PANEL_OVERLAY_NAME, __scopePanel);
      const composedRefs = useComposedRefs(forwardedRef, context.contentRef);

      return (
        <Presence present={forceMount || context.open}>
          <Primitive.div
            className={className}
            data-state={getPanelState(context.open)}
            style={{
              pointerEvents: 'auto',
              ...style,
            }}
            {...restOfProps}
            onClick={composeEventHandlers(restOfProps.onClick, context.onOpenClose)}
            ref={composedRefs}
          />
        </Presence>
      );
    },
  ),
);

PanelOverlay.displayName = 'PanelOverlay';
